module.exports = __webpack_public_path__ + "static/media/d11.c201c4be.jpg";